var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: { error: errors[0], label: "Nombre:" },
                      model: {
                        value: _vm.value.nameFirst,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "nameFirst", $$v)
                        },
                        expression: "value.nameFirst"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: {
                        error: errors[0],
                        label: "Inicial:",
                        maxlength: "1"
                      },
                      model: {
                        value: _vm.value.nameInitial,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "nameInitial", $$v)
                        },
                        expression: "value.nameInitial"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: { error: errors[0], label: "Apellido Paterno:" },
                      model: {
                        value: _vm.value.nameLastPaternal,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "nameLastPaternal", $$v)
                        },
                        expression: "value.nameLastPaternal"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("custom-input", {
            attrs: { label: "Apellido Materno:" },
            model: {
              value: _vm.value.nameLastMaternal,
              callback: function($$v) {
                _vm.$set(_vm.value, "nameLastMaternal", $$v)
              },
              expression: "value.nameLastMaternal"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: { error: errors[0], label: "Departamento:" },
                      model: {
                        value: _vm.value.workDepartmentName,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "workDepartmentName", $$v)
                        },
                        expression: "value.workDepartmentName"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: { error: errors[0], label: "Posición:" },
                      model: {
                        value: _vm.value.workPositionTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "workPositionTitle", $$v)
                        },
                        expression: "value.workPositionTitle"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: { rules: "required|email" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: { error: errors[0], label: "Correo Electrónico:" },
                      model: {
                        value: _vm.value.email,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "email", $$v)
                        },
                        expression: "value.email"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: {
              name: "Celular",
              rules: _vm.isRequiredPhones ? "required|length:14" : "length:14"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: {
                        "custom-error-msg": _vm.validationMessages.required,
                        error: errors[0],
                        label: "Celular:",
                        "mask-type": "Phone",
                        masked: true,
                        placeholder: "(___) ___-____"
                      },
                      model: {
                        value: _vm.value.telephoneMobileNo,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "telephoneMobileNo", $$v)
                        },
                        expression: "value.telephoneMobileNo"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-sm-12 col-md-4 mb-3" }, [
        _c(
          "div",
          { staticClass: "col-sm-8 col-lg-8 float-left px-0" },
          [
            _c("validation-provider", {
              ref: _vm.validationGroup,
              attrs: {
                name: "Trabajo",
                rules: _vm.isRequiredPhones ? "required|length:14" : "length:14"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg": _vm.validationMessages.required,
                          error: errors[0],
                          label: "Trabajo:",
                          "mask-type": "Phone",
                          masked: true,
                          placeholder: "(___) ___-____"
                        },
                        model: {
                          value: _vm.value.telephoneWorkNo,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "telephoneWorkNo", $$v)
                          },
                          expression: "value.telephoneWorkNo"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-4 col-lg-4 float-left pl-3 pr-0" },
          [
            _c("custom-input", {
              attrs: { label: "Ext:", "mask-type": "PhoneExt", masked: true },
              model: {
                value: _vm.value.telephoneWorkExtNo,
                callback: function($$v) {
                  _vm.$set(_vm.value, "telephoneWorkExtNo", $$v)
                },
                expression: "value.telephoneWorkExtNo"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: {
              name: "Fax",
              rules: _vm.isRequiredPhones ? "required|length:14" : "length:14"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: {
                        "custom-error-msg": _vm.validationMessages.required,
                        error: errors[0],
                        label: "Fax:",
                        "mask-type": "Phone",
                        masked: true,
                        placeholder: "(___) ___-____"
                      },
                      model: {
                        value: _vm.value.telephoneHomeFaxNo,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "telephoneHomeFaxNo", $$v)
                        },
                        expression: "value.telephoneHomeFaxNo"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: {
              name: "Hogar",
              rules: _vm.isRequiredPhones ? "required|length:14" : "length:14"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: {
                        "custom-error-msg": _vm.validationMessages.required,
                        error: errors[0],
                        label: "Hogar:",
                        "mask-type": "Phone",
                        masked: true,
                        placeholder: "(___) ___-____"
                      },
                      model: {
                        value: _vm.value.telephoneHomeNo,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "telephoneHomeNo", $$v)
                        },
                        expression: "value.telephoneHomeNo"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: { name: "EstatusCivil", rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-drop-down", {
                      attrs: {
                        "custom-error-msg": "Campo Requerido",
                        error: errors[0],
                        fieldkey: "id",
                        fieldname: "name",
                        label: "Estatus Civil:",
                        options: _vm.civilStatuses,
                        placeholder: "Seleccione"
                      },
                      model: {
                        value: _vm.value.civilStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "civilStatus", $$v)
                        },
                        expression: "value.civilStatus"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-4 mb-3" },
        [
          _c("validation-provider", {
            ref: _vm.validationGroup,
            attrs: { name: "Municipality", rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      attrs: {
                        "custom-error-msg": "Campo Requerido",
                        error: errors[0],
                        label: "Municipio de Residencia:"
                      },
                      model: {
                        value: _vm.value.municipality,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "municipality", $$v)
                        },
                        expression: "value.municipality"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }